export enum ErrorCode {
  OK = "0",
  FAIL = "1"
}
